import config from '@/shared/config/config';
import { readEnv } from '@/shared/lib/util/runtimeEnv';

export const getEnvironmentLabel = () => {
  const hostname = window.location.hostname.toLowerCase();

  switch (true) {
    case hostname.startsWith('portal.dev'):
      return 'DEV';

    case hostname.startsWith('portal.qa'):
      return 'QA';

    case !hostname.startsWith('portal'):
      return 'LOCAL';

    default:
      return 'PROD';
  }
};

export const getClientIpAddress = async (): Promise<string> => {
  const response = await fetch('https://api.ipify.org?format=json');
  const data = await response.json();
  return data.ip ?? '';
};

export const isProd = () => getEnvironmentLabel() === 'PROD';
export const isQA = () => getEnvironmentLabel() === 'QA';
export const isLocal = () => getEnvironmentLabel() === 'LOCAL';

export const getServerAccessUrl = () => {
  const graphqlEndpoint = readEnv('GRAPHQL_ENDPOINT');
  if (graphqlEndpoint) {
    const serverURL = graphqlEndpoint.replace('/graphql', '');
    return serverURL;
  } else {
    throw new Error('GRAPHQL_ENDPOINT environment variable is not defined.');
  }
};

export const getChartsBaseUrl = () => {
  // Explicit override wins: a full origin (e.g. https://rx.qa.truentity.net) configured per env,
  // so the chart URL need not carry the legacy `server` label.
  if (config.CHARTS_BASE_URL) {
    return new URL(config.CHARTS_BASE_URL).origin;
  }
  // Fallback: derive from the API host by prepending the subdomain (local/IP left as-is).
  const url = new URL(getServerAccessUrl());
  const host = url.hostname;
  const subdomain = config.CHARTS_SUBDOMAIN;
  const isLocalHost = host === 'localhost' || host.endsWith('.localhost') || /^[\d.]+$/.test(host);
  if (!isLocalHost && subdomain && !host.startsWith(`${subdomain}.`)) {
    url.hostname = `${subdomain}.${host}`;
  }
  return url.origin;
};
